import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { SpaceConfigPageProps } from './components/SpaceConfigPage.tsx';

export const ShareableLinkSpaceAdminConfigurationLoader: LoadableType<
	Omit<SpaceConfigPageProps, 'flags'>
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSpaceConfiguration" */ './components/SpaceConfigPage.tsx'
			)
		).SpaceConfigPage,
});
